import React, {FC} from 'react';
import {NavigationList} from './NavigationList';
import style from '../style.module.scss';

export const HeaderExtraLinks: FC = () => (
    <nav className={style.headerExtra}>
        <ul className={style.headerExtraLinks} role={'tablist'}>
            <NavigationList />
        </ul>
    </nav>
);
